import { render, staticRenderFns } from "./IncidentDetailCard.vue?vue&type=template&id=2900340d&scoped=true"
import script from "./IncidentDetailCard.vue?vue&type=script&lang=js"
export * from "./IncidentDetailCard.vue?vue&type=script&lang=js"
import style0 from "./IncidentDetailCard.vue?vue&type=style&index=0&id=2900340d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2900340d",
  null
  
)

export default component.exports